import { HttpEvent, HttpHandlerFn, HttpRequest } from "@angular/common/http";
import { catchError, from, Observable, switchMap } from "rxjs";
import { AuthService } from "~modules/auth/auth.service";

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<any>> {
  const authService = new AuthService();
  return from(Promise.all([authService.fetchToken()])).pipe(
    switchMap(([data]) => {
      const accessToken = data?.accessToken.toString();
      const idToken = data?.idToken.toString();

      // Clone the request and add the Authorization header
      const newReq = req.clone({
        setHeaders: {
          "Access-Control-Allow-Origin": "*",
          Authorization: `Bearer ${accessToken}`,
          "x-id-token": idToken,
        },
      });

      // Pass the new request to the next handler
      return next(newReq);
    }),
    catchError((error) => {
      console.error("Could not retrieve access token:", error);
      return next(req);
    }),
  );
}
